// extracted by mini-css-extract-plugin
export default {"report-title":"ReportTitle_report-title__Xf2v0","title":"ReportTitle_title__IJ-yG","sub-title":"ReportTitle_sub-title__8JKKZ"};